import { render, staticRenderFns } from "./AllStartupsTable.vue?vue&type=template&id=710849e8&scoped=true&"
import script from "./AllStartupsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./AllStartupsTable.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710849e8",
  null
  
)

export default component.exports